import React from 'react';
import { useState, useEffect } from "react";
import axiosConfig from "../axiosConfig";
import Header from '../Header/Header';
import MainMenu from '../MainMenu/MainMenu';
import Cookies from 'universal-cookie';
import Select from 'react-select';
import { set } from 'date-fns';

const ChannelSubscriptionLists = () => {

    function pad(n) {
        return n < 10 ? '0' + n : n;
    }

    const now = new Date();
    const todayDate = now.getFullYear() + '-' +
        pad(now.getMonth() + 1) + '-' +
        pad(now.getDate());

    //const cookies = new Cookies();
    const [channelId, setChannelId] = useState("");
    const [selectedChannel, setSelectedChannel] = useState(null); // store the full selected option
    const [filterName, setFilterName] = useState("");
    const [start, setStart] = useState(todayDate);
    const [finish, setFinish] = useState(todayDate);
    const [isContinueChecked, setIsContinueChecked] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [dataTypes, setDataTypes] = useState([]);
    const [selectedDataTypes, setSelectedDataTypes] = useState([]); // full selected options
    const [channelSubscriptionListData, setChannelSubscriptionListData] = useState(null);
    const [channels, setchannels] = useState([]);
    const [allUserFilterData, setAllUserFilterData] = useState([]);
    const [err_msg, setErrMsg] = useState({});
    const [query, setQuery] = useState("");

    const dataTypeOptions = [
        { value: 'Viewership', label: 'Viewership' },
        { value: 'Commercial Log', label: 'Commercial Log' },
        { value: 'Programme Log', label: 'Programme Log' }
    ];


    const [editRowId, setEditRowId] = useState(null);
    const [editFinish, setEditFinish] = useState("");
    const [editIsContinue, setEditIsContinue] = useState(false);


    const fetchChannelSubscriptionListsData = () => {
        axiosConfig.get("/channel/subscription/list")
            .then(res => {
                //console.log(res.data);
                setChannelSubscriptionListData(res.data);

            })
            .catch(err => {
                //console.error(" error", err);
            });
    };



    useEffect(() => {
        axiosConfig.get("/user/userfilterdata/list").then((rsp) => {
            setAllUserFilterData(rsp.data);
            //console.log(rsp.data[0]);
        }, (err) => { });

        axiosConfig.get("/trend/channels").then(rsp => {
            //console.log(rsp.data);
            setchannels(rsp.data.channels);
            //console.log(channels);

        }).catch(err => {

        })


        fetchChannelSubscriptionListsData();


    }, []);

    const AddData = () => {

        var data = {
            filter_name: filterName,
            channel_id: channelId,
            start: start,
            finish: finish,
            continue: isContinueChecked, // ✅ include this
            remarks: remarks,
            data_types: dataTypes, // ✅ use here

        };

        axiosConfig.post("/channel/subscription/add", data).then((rsp) => {
            alert(rsp.data.message);
            //window.location.href = "/device";
            //window.location.href = `/userdatafilter`;
            setErrMsg("");

            setFilterName("");
            setChannelId("");
            setSelectedChannel(null); // Reset the selected channel
            setStart(todayDate);
            setFinish(todayDate);
            setIsContinueChecked(false);
            setRemarks("");
            setSelectedDataTypes([]);
            setDataTypes([]);


            fetchChannelSubscriptionListsData(); // Refresh the list after adding new data


        }, (err) => {
            if (err.response.status === 422) {
                setErrMsg(err.response.data);
                //console.log(err.response.data);

            }
        });

        fetchChannelSubscriptionListsData(); // Refresh the list after adding new data

    }


    const removeSubscription = (id) => {
        axiosConfig.delete(`/channel/subscription/delete/${id}`)
            .then((rsp) => {
                alert(rsp.data.message);
                fetchChannelSubscriptionListsData(); // Refresh the list after deletion
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    setErrMsg(err.response.data);
                    //console.log(err.response.data);
                } else if (err.response.status === 404) {
                    alert(err.response.data.message || "Subscription not found.");

                } else {
                    alert("Error removing subscription. Please try again.");
                }
            });
    };



    const handleUpdateFinish = (id) => {
        const payload = {
            editFinish: editIsContinue ? null : editFinish,
        };

        axiosConfig.post(`/channel/subscription/edit/${id}`, payload)
            .then((res) => {
                alert(res.data.message);
                setErrMsg({});
                setEditRowId(null);
                fetchChannelSubscriptionListsData(); // reload updated list
            })
            .catch((err) => {
                setErrMsg(err.response.data);
                alert("Update failed.");
                console.error(err);
            });
    };




    const Search = (data) => {
        return data?.filter(
            (item) =>
                item.filter_name.toLowerCase().includes(query.toLowerCase())
            // || item.id.toString().includes(query)
        );
    };


    const modify_date = (date) => {

        return new Date(date).toLocaleString(undefined, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            //hour: '2-digit',
            //minute: '2-digit',
        });
    }


    return (
        <div><Header title="Manage Temporary Offline Channels & Reports" />
            <MainMenu menu="channel-subscriptions" />

            {/* <div class="app-content content"> */}
            <div class=" content">
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >

                    <div class="content-body">

                        <div class="card">
                            <br />
                            <div class="row card-content collapse show">

                                <div class="col-md pl-2">
                                    <br />
                                    <button type="submit" onClick={AddData} class="form-control btn-sm btn-info font-weight-bold" >+ Add filter</button>
                                </div>
                                <div class="col-md">
                                    <label for="dateTime1" class="font-weight-bold">Filter Name</label>
                                    <input type="text" class="form-control" value={filterName} onChange={(e) => { setFilterName(e.target.value) }} name="filter_name" placeholder="name" />
                                    <span class="text-danger">{err_msg.filter_name ? err_msg.filter_name[0] : ''}</span>
                                </div>
                                <div class="col-md">
                                    <label for="dateTime1" class="font-weight-bold">Channel Name</label>
                                    <Select
                                        placeholder="Select channel"
                                        options={channels.map(channel => ({ label: channel.name, value: channel.id }))}
                                        onChange={opt => {
                                            setSelectedChannel(opt); // Store the full selected option
                                            setChannelId(opt.value);
                                        }}
                                        value={selectedChannel} // Use the stored option
                                    />
                                    <span class="text-danger">{err_msg.channel_id ? err_msg.channel_id[0] : ''}</span>
                                </div>

                                <div class="col-md-3">
                                    <div class="row">
                                        <fieldset class="form-group form-group-style col-md-6">
                                            <label for="startDate">Start Date</label>
                                            <input
                                                type="date"
                                                class="form-control"
                                                id="startDate"
                                                value={start}
                                                onChange={(e) => setStart(e.target.value)}
                                            />
                                        </fieldset>

                                        <fieldset class="form-group form-group-style col-md-6">
                                            <label for="finishDate">Finish Date</label>
                                            <input
                                                type="date"
                                                class="form-control"
                                                id="finishDate"
                                                value={finish}
                                                onChange={(e) => setFinish(e.target.value)}
                                                disabled={isContinueChecked}
                                            />
                                        </fieldset>
                                    </div>
                                    <span class="text-danger">{err_msg.start ? err_msg.start[0] : ''}</span><br />
                                    <span class="text-danger">{err_msg.finish ? err_msg.finish[0] : ''}</span>
                                </div>


                                <div className="col-md pl-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="continueCheck"
                                        checked={isContinueChecked}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setIsContinueChecked(checked);
                                            if (checked) setFinish("")   // 🔹 clear the finish time
                                            else setFinish(todayDate);    // If checked, clear finish time

                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="continueCheck">Continue</label>

                                </div>


                                <div class="col-md">
                                    <label for="remarks" class="font-weight-bold">Remarks</label>
                                    <input type="text" class="form-control" value={remarks} onChange={(e) => { setRemarks(e.target.value) }} name="remarks" placeholder="Remarks" />
                                    <span class="text-danger">{err_msg.remarks ? err_msg.remarks[0] : ''}</span>
                                </div>


                                <div className="col-md pr-3">
                                    <label className="font-weight-bold">Data Type</label>
                                    <Select
                                        isMulti
                                        name="dataTypes"
                                        options={dataTypeOptions}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Select Data Types"
                                        onChange={(selectedOptions) => {
                                            setSelectedDataTypes(selectedOptions); // full objects
                                            setDataTypes(selectedOptions.map(opt => opt.value)); // values only
                                        }}
                                        value={selectedDataTypes} // controlled value
                                    />
                                    <span className="text-danger">
                                        {err_msg.data_types ? err_msg.data_types[0] : ''}
                                    </span>
                                </div>

                            </div>

                        </div>


                        <div class="row justify-content-md-center">
                            <div class="col-12">
                                <div class="card">

                                    <div class="card-content collapse show">
                                        <div class="card-body card-dashboard">

                                            <div class="row">
                                                <div class="col-md-7"><div class="h3 font-weight-bold">Subscription Based Filter Data</div></div>
                                                <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search Filter Name" onChange={e => setQuery(e.target.value)} />
                                                </div>


                                            </div>
                                            <br />
                                            <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                <table class="table display nowrap table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Filter Name</th>
                                                            <th>Channel Name</th>
                                                            <th>Channel ID</th>
                                                            <th>Start</th>
                                                            <th>Finish</th>
                                                            <th>Remarks</th>
                                                            <th>Data Types</th>
                                                            <th>Operation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Search(channelSubscriptionListData)?.map((channelSubscriptionData) => (
                                                            <tr key={channelSubscriptionData.id}>
                                                                <td>{channelSubscriptionData.filter_name}</td>
                                                                <td>{channelSubscriptionData.channel.channel_name}</td>
                                                                <td>{channelSubscriptionData.channel_id}</td>
                                                                <td>{channelSubscriptionData.start}</td>

                                                                <td>
                                                                    {editRowId === channelSubscriptionData.id ? (
                                                                        <>
                                                                            <input
                                                                                type="date"
                                                                                className="form-control form-control-sm"
                                                                                value={editFinish}
                                                                                onChange={(e) => setEditFinish(e.target.value)}
                                                                                disabled={editIsContinue}
                                                                            />
                                                                            <div className="form-check mt-1">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    id={`editContinue-${channelSubscriptionData.id}`}
                                                                                    checked={editIsContinue}
                                                                                    onChange={(e) => {
                                                                                        setEditIsContinue(e.target.checked);
                                                                                        if (e.target.checked) setEditFinish("");
                                                                                        else setEditFinish(channelSubscriptionData.finish == null ? todayDate : channelSubscriptionData.finish); // If checked, clear finish time
                                                                                    }}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`editContinue-${channelSubscriptionData.id}`}>
                                                                                    Continue
                                                                                </label>

                                                                                <br /> <span class="text-danger">{err_msg.editFinish ? err_msg.editFinish[0] : ''}</span>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        channelSubscriptionData.finish ? (
                                                                            modify_date(channelSubscriptionData.finish)
                                                                        ) : (
                                                                            <span className="badge badge-success">Continue</span>
                                                                        )
                                                                    )}
                                                                </td>

                                                                <td>{channelSubscriptionData.remarks}</td>

                                                                <td>
                                                                    {channelSubscriptionData.data_types.map((type, index) => (
                                                                        <span key={index} className="badge badge-primary mr-1">
                                                                            {type}
                                                                        </span>
                                                                    ))}
                                                                </td>
                                                                
                                                                <td>{channelSubscriptionData.channel_id}</td>

                                                                <td>
                                                                    {editRowId === channelSubscriptionData.id ? (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-success mr-1"
                                                                                onClick={() => handleUpdateFinish(channelSubscriptionData.id)}
                                                                            >
                                                                                Submit
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-secondary"
                                                                                onClick={() => setEditRowId(null)}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-primary mr-1"
                                                                                onClick={() => window.location.href = `/channel-subscription-history/${channelSubscriptionData.channel_id}`}
                                                                            >
                                                                                History
                                                                            </button>
                                                                            <button className="btn btn-sm btn-info mr-1" onClick={() => {
                                                                                setEditRowId(channelSubscriptionData.id);
                                                                                setEditFinish(channelSubscriptionData.finish || "");
                                                                                setEditIsContinue(channelSubscriptionData.finish === null);
                                                                            }}>Edit</button>
                                                                            <button className="btn btn-sm btn-danger" onClick={() => {
                                                                                if (window.confirm("Are you sure you want to delete this filter?")) {
                                                                                    removeSubscription(channelSubscriptionData.id);
                                                                                }
                                                                            }}>Remove</button>
                                                                        </>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>


                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    )
}
export default ChannelSubscriptionLists